/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import Message from '../../Common/Message/Message';
import editIcon from '../../../images/icons/edit-white.svg';
import './Stripe.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let terminal = window.StripeTerminal;

class Stripe extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            validation: {
                client_name: {
                    valid: null,
                    msg: ''
                },
                billing_address_1: {
                    valid: null,
                    msg: ''
                },
                client_email: {
                    valid: null,
                    msg: ''
                },
                client_phone: {
                    valid: null,
                    msg: ''
                },
                billing_city: {
                    valid: null,
                    msg: ''
                },
                billing_country: {
                    valid: true,
                    msg: ''
                },
                billing_state: {
                    valid: true,
                    msg: ''
                },
                billing_contact: {
                    valid: null,
                    msg: ''
                },
                billing_zip: {
                    valid: null,
                    msg: ''
                }
            },
            isReadyToSubmit : false,
            isDisabled: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            newDevices: [],
            existingDevices: [],
            selectedDevice: {},
            stripe_accounts: [],
        };
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    handleChange = (e, index) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        const newDevices = this.state.newDevices;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        
        newDevices[index][name] = value;
        this.setState({
            newDevices,
        });
    }

    handleExistingChange = (e, index) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        const existingDevices = this.state.existingDevices;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        existingDevices[index][name] = value;
        this.setState({
            existingDevices,
        });
    }

    componentDidMount = () => {
        this.getStripeAccounts();

        if (sessionStorage.getItem('connected_device')) {
            this.setSelectedDevice();
        }
    }

    componentWillReceiveProps(props) {
        if(props.isUpdateClient){
            //this.updateClient();
        }
    }

    addDevice = () => {
        const newDevices = this.state.newDevices;
        let newDevice = {
            registration_code: '',
            label: '',
        }
        newDevices.push(newDevice);
        this.setState({
            newDevices,
        });
    }

    registerDevice = async (index) => {
        this.setMessage('', '', 'loading');
        let newDevices = this.state.newDevices;
        try {
            const registerResponse = await register(newDevices[index]);
            console.log(registerResponse);
            if (registerResponse.data.reader) {
                this.setMessage(window.general_strings.msg.yay, `The terminal ${registerResponse.data.reader.label} - ${registerResponse.data.reader.serial_number} has been registered successfully!`, 'success');
                let existingDevices = this.state.existingDevices;
                newDevices.splice(index, 1);
                let newDevice = registerResponse.data.reader;
                newDevice.isEditMode = false;
                existingDevices.forEach((existingDevice) => {
                    existingDevice.isEditMode = false;
                    existingDevice.label_previous = existingDevice.label;
                    existingDevice.id_previous = existingDevice.id;
                });
                existingDevices.push(registerResponse.data.reader);
                this.setState({
                    newDevices,
                    existingDevices,
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, registerResponse.data.error.messageText, 'error');
                newDevices[index].registration_code = '';
                this.setState({
                    newDevices,
                });
            }

            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        } catch (error) {
            console.log(error);
        }

		async function register(newDevice) {
            let data = {
                registration_code: newDevice.registration_code,
                label: newDevice.label
            }
			return await ApiRequest(`/stripe/reader/register`, {
                method: 'POST',
                data,
            });
        }
    }

    cancelDevice = async (index) => {
        const newDevices = this.state.newDevices;
        newDevices.splice(index, 1);
        this.setState({
            newDevices,
        });
    }

    setSelectedDevice = () => {
        let selectedDevice = this.state.selectedDevice;
        selectedDevice = JSON.parse(sessionStorage.getItem('connected_device'));
        this.setState({
            selectedDevice,
        });
    }

    getStripeAccounts = async () => {
        try {
            const accountsResponse = await getAccounts();
            console.log('accountsResponse: ', accountsResponse);
            this.setState({
                stripe_accounts: accountsResponse.data.stripe_accounts
            }, () => {
                this.getDevices();
            });
        } catch (error) {
            console.log(error);
        }

		async function getAccounts() {
			return await ApiRequest(`/clients/current/stripe-accounts`, {
                method: 'GET'
            });
        }
    }

    getStripeDashboards = () => {
        const stripe_accounts = this.state.stripe_accounts;
        let hasEvent = false;
        let event;
        let hasDonation = false;
        let donation;
        if (stripe_accounts) {
            stripe_accounts.forEach((account) => {
                if (account.type === 'connect' && account.dashboard !== '') {
                    hasEvent = true;
                    event = account;
                }
                if (account.type === 'connect-alt' && account.dashboard !== '') {
                    hasDonation = true;
                    donation = account;
                }
            });
    
            if (!hasEvent && !hasDonation) {
                return (
                    <React.Fragment>
                        <p>To use ShowTix4U POS Terminal, you will need to be on Recurring Electronic Payouts. To signup, choose "<a href="/client/billing">Billing/Banking</a>"" under Preferences in the Main Menu.</p>
                    </React.Fragment>
                    
                );
            } else {
                return (
                    <React.Fragment>
                        <p>Please make sure that your reader is on the same network or Wi-Fi. Also, make sure you're using the latest version of Chrome, Firefox or Safari to allow the reader to connect properly.</p>
                        <button className="showtix-button showtix-background__primary-1" onClick={() => this.addDevice()}>Add a new device</button>
                    </React.Fragment>
                )
            }
        }
    }

    getDevices = async () => {
        this.setMessage('','','loading');
        let existingDevices = this.state.existingDevices;
        try {
            const getReadersResponse = await getReaders();
            console.log('getReadersResponse', getReadersResponse);
            if (getReadersResponse.data.readers) {
                existingDevices = getReadersResponse.data.readers;
                existingDevices.forEach((existingDevice) => {
                    existingDevice.isEditMode = false;
                    existingDevice.label_previous = existingDevice.label;
                    existingDevice.id_previous = existingDevice.id;
                });
                this.setState({
                    existingDevices,
                });
            }
            this.setMessage('','','');
        } catch (error) {
            console.log(error);
        }

		async function getReaders() {
			return await ApiRequest(`/stripe/readers`, {
                method: 'GET',
            });
        }
    }

    setDefaultDevice = async (selectedDevice) => {
        this.setMessage('', '', 'loading');
        const _this = this;
        async function fetchConnectionToken() {
            // Your backend should call /v1/terminal/connection_tokens and return the JSON response from Stripe
            const response = await fetch(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/stripe/reader/connection-token`, { 
                method: "POST",
                credentials: 'include'
            });
            const data = await response.json();
            if (data.secret) {
                return data.secret;
            } else {
                _this.setMessage(window.general_strings.msg.oops, data.error.messageText, 'error');
                setTimeout(() => {
                    _this.setMessage('','','');
                }, 5000);
            }
        }

        function unexpectedDisconnect() {
            alert('Connection lost! Please reconnect your reader.');
            sessionStorage.removeItem('connected_device');
        }

        terminal = window.StripeTerminal.create({
            onFetchConnectionToken: fetchConnectionToken,
            onUnexpectedReaderDisconnect: unexpectedDisconnect,
        });

        const connectResult = await terminal.connectReader(selectedDevice);
        if (connectResult.error) {
            _this.setMessage(window.general_strings.msg.oops, `Failed to connect ${connectResult.error.message}`, 'error');
        } else {
            _this.setMessage(window.general_strings.msg.yay, `Connected to reader ${connectResult.reader.label}`, 'success');
            sessionStorage.setItem('connected_device', JSON.stringify(selectedDevice));
            _this.setState({
                selectedDevice,
            });
        }
        setTimeout(() => {
            _this.setMessage('', ``, '');
        }, 5000);
    }

    removeDevice = async (id) => {
        this.setMessage('','','loading');
        try {
            const removeResponse = await remove(id);
            console.log(removeResponse);

            if (removeResponse.data.success) {
                this.setMessage(window.general_strings.msg.yay,'Terminal deleted successfully.','success');
            } else {
                this.setMessage(window.general_strings.msg.oops,'There has been an error while deleting your terminal.','error');
            }
        } catch (error) {
            console.log(error);
        }

		async function remove(id) {
			return await ApiRequest(`/stripe/reader/${id}`, {
                method: 'DELETE',
            });
        }

        setTimeout(() => {
            this.setMessage('', ``, '');
            this.getDevices();
        }, 5000);
    }

    editDevice = (index) => {
        const existingDevices = this.state.existingDevices;
        existingDevices[index].isEditMode = true;
        this.setState({
            existingDevices,
        });
    }

    updateDevice = async (index) => {
        const existingDevices = this.state.existingDevices;
        let existingDevice = existingDevices[index];
        this.setMessage('','','loading');
        try {
            const updateResponse = await update(existingDevice);
            console.log(updateResponse);

            if (updateResponse.data.reader) {
                let existingDevices = this.state.existingDevices;
                existingDevices[index] = updateResponse.data.reader;
                existingDevices[index].isEditMode = false;
                existingDevices[index].label_previous = existingDevices[index].label;
                existingDevices[index].id_previous = existingDevices[index].id;
                this.setState({
                    existingDevices,
                });
                this.setMessage(window.general_strings.msg.yay,'Terminal updated successfully.','success');
            } else {
                this.setMessage(window.general_strings.msg.oops,updateResponse.data.error.code.code,'error');
            }
            
        } catch (error) {
            console.log(error);
        }

		async function update(existingDevice) {
            let data = {
                stripe_reader_id: existingDevice.id,
                label: existingDevice.label,
            }
			return await ApiRequest(`/stripe/reader/${existingDevice.id_previous}`, {
                method: 'PUT',
                data,
            });
        }

        setTimeout(() => {
            this.setMessage('', ``, '');
        }, 5000);
    }

    cancelEdit = (index) => {
        const existingDevices = this.state.existingDevices;
        existingDevices[index].isEditMode = false;
        if (existingDevices[index]["id_previous"]) {
            existingDevices[index]["id"] = existingDevices[index]["id_previous"];
            existingDevices[index]["id_previous"] = null;
        }
        if (existingDevices[index]["label_previous"]) {
            existingDevices[index]["label"] = existingDevices[index]["label_previous"];
            existingDevices[index]["label_previous"] = null;
        }
        this.setState({
            existingDevices,
        });
    }

    renderNewDevices = () => {
        return (
            <div className="row mt-4">
                {this.state.newDevices.map((newDevice, i) => (
                    <div className="col-12">
                        <h2>{strings.terminal}</h2>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="registrationCode">{strings.registrationCode}</label>

                                    <div className="showtix-form__input">
                                        <input
                                            id="registrationCode"
                                            className="showtix-input"
                                            type="text"
                                            name="registration_code"
                                            value={newDevice.registration_code || ''}
                                            onChange={(e) => this.handleChange(e, i)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="label">{strings.label}</label>

                                    <div className="showtix-form__input">
                                        <input
                                            id="label"
                                            className="showtix-input"
                                            type="text"
                                            name="label"
                                            value={newDevice.label || ''}
                                            onChange={(e) => this.handleChange(e, i)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="showtix-form__group">
                            <button className="showtix-button showtix-background__primary-2" onClick={() => this.registerDevice(i)}>Register</button>
                            <button className="showtix-button showtix-background__grey-1" onClick={() => this.cancelDevice(i)}>Cancel</button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderExistingDevices = () => {
        if (this.state.existingDevices.length > 0) {
            return (
                <div className="showtix-section showtix-background__primary-2">
                    <div className="container">
                        <h2>{strings.existingTerminals}</h2>
                        {this.state.existingDevices.map((existingDevice, i) => (
                            existingDevice.isEditMode ? (
                                <div className="row showtix-device">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="existingLabel">{strings.label}</label>

                                            <div className="showtix-form__input">
                                                <input
                                                    id="existingLabel"
                                                    className="showtix-input"
                                                    type="text"
                                                    name="label"
                                                    value={existingDevice.label}
                                                    onChange={(e) => this.handleExistingChange(e, i)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="existingId">{strings.id}</label>

                                            <div className="showtix-form__input">
                                                <input
                                                    id="existingId"
                                                    className="showtix-input"
                                                    type="text"
                                                    name="id"
                                                    value={existingDevice.id}
                                                    onChange={(e) => this.handleExistingChange(e, i)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.cancelEdit(i)}
                                        >
                                            {strings.cancel}
                                            
                                        </button>
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={() => this.updateDevice(i)}
                                        >
                                            {strings.update}
                                            
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="row showtix-device">
                                    <div className="col-12">
                                        <h3>
                                            <button
                                                className="showtix-device__edit"
                                                onClick={() => this.editDevice(i)}
                                                >
                                                <img src={editIcon} alt="Edit" />
                                            </button>
                                            {existingDevice.label}
                                            <span className={"showtix-badge " + (existingDevice.status === 'online' ? 'shwotix-background__success' : 'showtix-background__grey-3')}>{existingDevice.status}</span>
                                            {this.state.selectedDevice.id === existingDevice.id && (
                                                <span className={"showtix-badge showtix-background__primary-4"}>Default device</span>
                                            
                                            )}
                                        </h3>
                                        <p>
                                            <strong>ID</strong><br />
                                            {existingDevice.id}<br /><br />

                                            <strong>IP Address</strong><br />
                                            {existingDevice.ip_address}<br /><br />

                                            <strong>Serial Number</strong><br />
                                            {existingDevice.serial_number}
                                        </p>
                                        {this.state.selectedDevice.id !== existingDevice.id && (
                                            <button
                                                className="showtix-button showtix-background__primary-4"
                                                onClick={() => this.setDefaultDevice(existingDevice)}
                                            >
                                                {strings.makeDefault}
                                            </button>
                                        )}
                                        <button
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.removeDevice(existingDevice.id)}
                                        >
                                            {strings.removeDevice}
                                            
                                        </button>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                
                <div className="showtix-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <h1>{strings.title}</h1>
                                <p>Please make sure that your reader is on the same network or Wi-Fi. Also, make sure you're using the latest version of Chrome, Firefox or Safari to allow the reader to connect properly.</p>
                                <button className="showtix-button showtix-background__primary-1" onClick={() => this.addDevice()}>Add a new device</button>
                                {/* this.getStripeDashboards() */}
                            </div>
                            <div className="col-md-4">
                                {strings.tips.map((help, i) =>
                                    <Help help={help} key={i} />
                                )}
                            </div>
                        </div>
                        {this.renderNewDevices()}
                    </div>
                </div>
                {this.renderExistingDevices()}
                
            </React.Fragment>
        );
    }
}

Stripe.propTypes = {
}

export default Stripe;



// WEBPACK FOOTER //
// ./src/components/Client/Stripe/Stripe.js